export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/image-cache.worker_541e659be9be0480cab7_bundle.worker.js");
}
